/*!
 * UNINSPIRED LP — animation init
 * Ported from adhd_hoodie_LP_wireframe_v10.html.
 * Embla and sticky-bar logic are intentionally omitted:
 *   - Embla: replaced by native CSS scroll-snap on the three rail sections.
 *   - Sticky bar: handled by assets/lp-sticky-cta.js.
 *
 * This script is only loaded by snippets/lp-anim-libs.liquid, which is only
 * rendered from sections/lp-config.liquid — so it only runs on pages using
 * the page.product-lp template. Queries are scoped to document; no wrapper.
 */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setFinalState() {
    document.querySelectorAll('.lp-fade-up, .lp-fade-in, .lp-scale-in').forEach(function (el) {
      el.style.opacity = 1;
      el.style.transform = 'none';
    });
    document.querySelectorAll('.lp-word-stagger > span').forEach(function (s) {
      s.style.opacity = 1;
      s.style.transform = 'none';
    });
    document.querySelectorAll('.lp-draw-y').forEach(function (d) {
      d.style.transform = 'scaleY(1)';
    });
  }

  if (reduced || !window.gsap || !window.ScrollTrigger) {
    setFinalState();
    return;
  }

  // Lenis smooth scroll
  if (window.Lenis) {
    var lenis = new window.Lenis({
      duration: 1.05,
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); }
    });
    function raf(time) {
      lenis.raf(time);
      window.requestAnimationFrame(raf);
    }
    window.requestAnimationFrame(raf);
  }

  gsap.registerPlugin(ScrollTrigger);

  // Hero hook: word-stagger on first paint
  gsap.to('.lp-word-stagger > span', {
    opacity: 1, y: 0, duration: 0.6, stagger: 0.08, ease: 'power2.out', delay: 0.1
  });

  // Hero subhead + CTAs: fade-up cascade after the word-stagger
  gsap.to('.lp-hero .lp-fade-up', {
    opacity: 1, y: 0, duration: 0.7, stagger: 0.08, ease: 'power2.out', delay: 0.55
  });

  // Hero video: fade-in on load + parallax on scroll
  gsap.to('.lp-hero__media', {
    opacity: 1, duration: 0.8, ease: 'power2.out'
  });
  gsap.to('.lp-hero__media', {
    yPercent: -8,
    ease: 'none',
    scrollTrigger: {
      trigger: '.lp-hero',
      start: 'top top',
      end: 'bottom top',
      scrub: true
    }
  });

  // Generic .lp-fade-up reveals on scroll (excluding hero + mood-grid groups,
  // which have their own staggered cascades above/below)
  document.querySelectorAll('.lp-fade-up').forEach(function (el) {
    if (el.closest('.lp-hero')) return;
    if (el.classList.contains('lp-mood-grid__group')) return;
    gsap.to(el, {
      opacity: 1, y: 0, duration: 0.6, ease: 'power2.out',
      scrollTrigger: { trigger: el, start: 'top 88%', toggleActions: 'play none none none' }
    });
  });

  // Generic .lp-fade-in reveals (no transform, just opacity)
  document.querySelectorAll('.lp-fade-in').forEach(function (el) {
    if (el.closest('.lp-hero')) return;
    gsap.to(el, {
      opacity: 1, duration: 0.7, ease: 'power2.out',
      scrollTrigger: { trigger: el, start: 'top 88%', toggleActions: 'play none none none' }
    });
  });

  // AR block timeline: lime border draws while private quote scales in
  if (document.querySelector('.lp-ar')) {
    var arTL = gsap.timeline({
      scrollTrigger: { trigger: '.lp-ar', start: 'top 75%', toggleActions: 'play none none none' }
    });
    arTL
      .to('.lp-ar .lp-draw-y', { scaleY: 1, duration: 0.5, ease: 'power2.inOut' }, 0)
      .to('.lp-ar .lp-scale-in', { opacity: 1, scale: 1, duration: 0.6, ease: 'power2.out' }, 0.3);
  }

  // Mood grid: theme-group stagger
  gsap.to('.lp-mood-grid__group', {
    opacity: 1, y: 0, duration: 0.6, stagger: 0.12, ease: 'power2.out',
    scrollTrigger: { trigger: '.lp-mood-grid', start: 'top 80%' }
  });
})();
